import { connect } from 'react-redux';
import { CustomQuestionList } from '../../components/questions/CustomQuestionList';
import { IAddedQuestion } from '../../models';
import { IApplicationState } from '../../store';
import { ActionCreators as CulturesActionCreators } from '../../store/CulturesStore';
import { ActionCreators } from '../../store/CustomQuestionListStore';
import { CustomQuestionColumnHelper } from '../../utilities';

export interface ICustomQuestionListContainerProps {
	addedQuestions: IAddedQuestion[];
	isDemographic: boolean;
	isFollowUp: boolean;
	parentQuestionId?: number;
	selectedCustomQuestionIds: number[];
	totalSelectedQuestions: number;
	onAddUpdateQuestionClick: (questionId?: number) => void;
}

export const mapStateToProps = (state: IApplicationState, props: ICustomQuestionListContainerProps) => {
	const columns = props.isDemographic
		? CustomQuestionColumnHelper.getCustomDemographicQuestionColumns()
		: CustomQuestionColumnHelper.getCustomSurveyQuestionColumns();
	return {
		...state.clientParticipantAttributes,
		...state.cultures,
		...state.customQuestionList,
		columns,
		defaultCultureCode: state.survey.surveyEditModel.defaultCultureCode,
		isDemographic: props.isDemographic,
		isFollowUp: props.isFollowUp,
		loading: state.customQuestionList.loading || state.clientParticipantAttributes.loading,
		parentQuestionId: props.parentQuestionId,
		selectedCustomQuestionIds: props.selectedCustomQuestionIds,
		surveyId: state.survey.surveyEditModel.survey.surveyId,
		surveySupportedCultures: state.survey.surveyEditModel.supportedCultures,
		totalSelectedQuestions: props.totalSelectedQuestions,
		onAddUpdateQuestionClick: props.onAddUpdateQuestionClick,
	};
};

export const CustomQuestionListContainer: React.ComponentType<ICustomQuestionListContainerProps> = connect(mapStateToProps, {
	...ActionCreators,
	...CulturesActionCreators,
})(CustomQuestionList);
